import state from './familyState'
import mutations from './familyMutations'
import getters from './familyGetters'
import actions from './familyActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
